import React, { useContext } from 'react';
import './MoodSnapshot.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardMoodSnapshotContext } from '../../contexts/CardMoodSnapshotContext';
import logComponent from '../../common/logComponent';

export default function MoodSnapshotLoadingStatus({ reloadAction }) {
  const cardMoodSnapshotContext = useContext(CardMoodSnapshotContext);
  const { moodSnapshotLoading, moodSnapshotError } = cardMoodSnapshotContext;

  if (logComponent('MoodSnapshotLoadingStatus')) { console.debug('MoodSnapshotLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={moodSnapshotLoading} isError={moodSnapshotError} reloadAction={reloadAction} />
  );
}